<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <circle cx="8.5" cy="8.5" r="8" fill="#3E8635" stroke="#3E8635" />
    <path
      d="M12 6.5L7.5 11L5 8.5"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
